import { render, staticRenderFns } from "./xcxSchemeUse.vue?vue&type=template&id=176a00e1&scoped=true"
import script from "./xcxSchemeUse.vue?vue&type=script&lang=js"
export * from "./xcxSchemeUse.vue?vue&type=script&lang=js"
import style0 from "./xcxSchemeUse.vue?vue&type=style&index=0&id=176a00e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176a00e1",
  null
  
)

export default component.exports